import React from "react";
interface props {
  className?: string;
}

function Icon5({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 42 42"
    >
      <circle cx="21" cy="20.996" r="20.5" stroke="#FF752C"></circle>
      <path
        stroke="#FF752C"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M26 19.805c0-.346 0-.519.052-.673.15-.448.55-.62.95-.803.448-.205.672-.307.895-.325.252-.02.505.034.72.155.287.16.487.466.69.714.944 1.146 1.416 1.72 1.588 2.35.14.51.14 1.044 0 1.553-.251.922-1.046 1.694-1.635 2.41-.301.365-.452.548-.642.655a1.27 1.27 0 01-.721.155c-.223-.018-.447-.12-.896-.325-.4-.182-.798-.355-.95-.803-.051-.154-.051-.327-.051-.673v-4.39zm-10 0c0-.436-.012-.827-.364-1.133-.128-.11-.298-.188-.637-.343-.45-.204-.673-.307-.896-.325-.667-.054-1.026.402-1.41.87-.944 1.145-1.416 1.718-1.59 2.35a2.94 2.94 0 000 1.553c.253.921 1.049 1.694 1.637 2.41.37.45.726.86 1.363.81.223-.019.447-.12.896-.326.34-.154.509-.232.637-.343.352-.306.364-.697.364-1.132v-4.39z"
      ></path>
      <path
        stroke="#FF752C"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14 18c0-3.314 3.134-6 7-6s7 2.686 7 6m0 8v.8c0 1.767-1.79 3.2-4 3.2h-2"
      ></path>
    </svg>
  );
}

export default Icon5;
